/* eslint-disable */
(() => {
  function removeActiveClassFromElements(elements) {
    elements.forEach((element) => element.classList.remove('active'));
  }

  function activateTab(tabElement, allTabs) {
    if (tabElement.classList.contains('active')) return;
    removeActiveClassFromElements(allTabs);
    tabElement.classList.add('active');
  }

  function activateTooltipTab(eventClick, tabElement) {
    const trigger = tabElement.attributes['data-trigger'].value;
    if (!trigger || trigger === 'recent' || trigger === 'future') return;

    if (eventClick && eventClick.target.closest('.tooltip')) {
      const tooltip = eventClick.target.closest('.tooltip');
      tooltip.classList.toggle('active');
    }

    if (tabElement && eventClick && !tabElement.querySelector('.tooltip').contains(eventClick.target.closest('.tooltip'))) {
      const tooltips = document.querySelectorAll('.tooltip');
      tooltips.forEach((tooltip) => {
        tooltip.classList.remove('active');
      });
    }
  }

  function loadTooltipTab(tabElement) {
    const trigger = tabElement.attributes['data-trigger'].value;
    if (!trigger || trigger === 'recent' || trigger === 'future') return;

    if (!tabElement.querySelector('.tooltip')) {
      const tooltip = document.createElement('div');
      tooltip.classList.add('tooltip');
      tooltip.textContent = 'i';
      tooltip.setAttribute('data-trigger', trigger);

      const tooltipText = document.createElement('span');
      tooltipText.classList.add('tooltip-text');
      tooltip.appendChild(tooltipText);

      tabElement.appendChild(tooltip);
      displayTooltipText(tooltip);
    }
  }

  async function displayTooltipText(tooltip) {
    const trigger = tooltip.attributes['data-trigger'].value;
    const tooltipText = tooltip.querySelector('.tooltip-text');
    const endpoint = trigger === 'visited' ? 'popular' : 'most-cited';

    jQuery.ajax({
      url: globalVars.ajax_url,
      type: 'POST',
      data: {
        action: 'tooltip_navigation_tab',
      },
      success: function(data){
        const tooltipData = data[endpoint];
        const { timeRange } = tooltipData;
        tooltipText.innerHTML = timeRange;
      },
      error: function(error){
        const tooltips = document.querySelectorAll('.tooltip');
        tooltips.forEach((tooltip) => {
          tooltip.classList.remove('active');
        });
        console.log(error);
      }
    });
  }

  function toggleLoopVisibility(activeTarget) {
    const { trigger } = activeTarget.dataset;
    const loops = document.querySelector('.wp-block-app-articles').querySelectorAll('.wp-block-query');

    loops.forEach((loop) => {
      const isTriggerLoop = loop.classList.contains(`${trigger}-loop`);
      loop.classList.toggle('hidden', !isTriggerLoop);
    });
  }

  function saveLastClickedTab(tabIndex) {
    localStorage.setItem('lastClickedTab', tabIndex);
  }

  function handleTabClick(tabElement, currentTab, allTabs) {
    activateTab(currentTab, allTabs);
    activateTooltipTab(tabElement, currentTab);
    toggleLoopVisibility(currentTab);
    // Save the index of the clicked tab to localStorage
    saveLastClickedTab(Array.from(allTabs).indexOf(currentTab));
  }

  function getLastClickedTab() {
    const lastItemActive = localStorage.getItem('lastClickedTab');
    const recentLoop = document.querySelector('.xl-title[data-trigger="recent"]');

    if (!document.querySelector('body.home') && lastItemActive !== null) {
      return lastItemActive;
    }

    return recentLoop;
  }

  function setInitialTabState() {
    const lastTab = getLastClickedTab();

    if (lastTab !== null) {
      const allTabs = document.querySelectorAll('.xl-title');
      const lastClickedIndex = parseInt(lastTab, 10);

      if (lastClickedIndex >= 0 && lastClickedIndex < allTabs.length) {
        removeActiveClassFromElements(allTabs);
        allTabs[lastClickedIndex].classList.add('active');
        toggleLoopVisibility(allTabs[lastClickedIndex]);
        activateTooltipTab(null, allTabs[lastClickedIndex]);
      }
    } else {
      const allTabs = document.querySelectorAll('.xl-title');
      removeActiveClassFromElements(allTabs);
    }
  }

  function initializeTabs() {
    const navigationTabsBlock = document.querySelector('.wp-block-app-navigation-tabs');
    const articleBlock = document.querySelector('.wp-block-app-articles');

    if (navigationTabsBlock && articleBlock) {
      const allTabs = navigationTabsBlock.querySelectorAll('.xl-title');
      const articleBlockQueries = articleBlock.querySelectorAll('.wp-block-query');

      articleBlockQueries.forEach((current) => {
        switch (current.localName) {
          case 'article-list-recent-tagname':
            current.classList.add('recent-loop');
            break;
          case 'article-most-cited-tagname':
            current.classList.add('cited-loop');
            break;
          case 'article-list-views-tagname':
            current.classList.add('visited-loop');
            break;
          case 'article-future-tagname':
            current.classList.add('future-loop');
            break;
          default:
            break;
        }
      });

      allTabs.forEach((tab) => {
        if (tab.classList.contains('active')) {
          toggleLoopVisibility(tab);
        }

        loadTooltipTab(tab);
        tab.addEventListener('click', (event) => handleTabClick(event, tab, allTabs));
      });

      document.addEventListener('DOMContentLoaded', setInitialTabState);
      document.addEventListener('click', (event) => {
        if (!navigationTabsBlock.contains(event.target)) {
          const tooltips = navigationTabsBlock.querySelectorAll('.tooltip');
          tooltips.forEach((tooltip) => {
            tooltip.classList.remove('active');
          });
        }
      });
    }
  }

  const futureLoop = document.querySelector('.future-loop');

  if (!futureLoop) {
    const futureTab = document.querySelector('.xl-title[data-trigger="future"]');

    if (futureTab) {
      futureTab.setAttribute('style', 'display:none;');
    }
  }

  initializeTabs();
})();
